import React from 'react';
import { FullTable } from 'components';
import { ReportsBody, ReportsHead, ReportsNotYet } from './constants';
import { sortListByKey, useModal } from 'utils';
import { GenerateReport, clientReportEnums } from './core';

export const ClientReports = ({}) => {
    const { open } = useModal();

    const openGenerate = (item) => {
        open(<GenerateReport info={item?.generateInfo} />);
    };

    return (
        <div>
            <FullTable
                head={ReportsHead}
                body={ReportsBody(openGenerate)}
                list={sortListByKey(clientReportEnums, 'name')}
                notYet={ReportsNotYet('Client')}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
